import react from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import styled from '../styled';
import fromTheme from '../fromTheme';
import { useTheme } from 'styled-components';

const rc = react.createElement;

const Anchor = styled.a`
    text-decoration: none;
    font-size: ${({ fontSize, theme }) => (fontSize ? fontSize : theme.linkFontSize)}px;
    color: ${fromTheme('linkColor')};
    margin-bottom: ${({ theme }) => theme.textMargin}px;
`;

const CenteredAnchor = styled.a`
    display: flex;
    text-decoration: none;
    font-size: ${({ fontSize, theme }) => (fontSize ? fontSize : theme.linkFontSize)}px;
    color: ${fromTheme('linkColor')};
    margin-bottom: ${({ theme }) => theme.textMargin}px;
    align-items: center;
    justify-content: center;
`;

const InlineIcon = styled(Icon)`
    margin-left: 3px;
`;

export default function ExternalLink(props) {
    const {
        url,
        title,
        includeExternalIcon = true,
        style,
        width,
        iconSize = '16px',
        className,
        openInNewWindow = true,
        iconName = 'open_in_new',
        ...otherAttrs
    } = props || {};
    const theme = useTheme();

    const target = openInNewWindow || includeExternalIcon ? '_blank' : '_self';

    const AnchorComponent = includeExternalIcon ? CenteredAnchor : Anchor;

    // prettier-ignore
    return rc(AnchorComponent, { target, href: url, style, width, className, ...otherAttrs },
        title,
        openInNewWindow && includeExternalIcon && rc(InlineIcon, { iconSize, fontColor: theme.linkColor }, iconName)
    );
}

ExternalLink.propTypes = {
    url: PropTypes.string,
    title: PropTypes.string
};
